module.exports = __webpack_public_path__ + "img/ss-8.6e337a66.png";